'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import H2 from 'UIComponents/elements/headings/H2';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import CoreVersionHistoryPanel from 'ecosystem-marketplace-core/components/versions/ThemeVersionHistoryPanel';
import { registerVersionHistoryQuery } from 'ecosystem-marketplace-core/queries/versionHistoryQuery';
import { getVersionHistory } from '../../clients/ecosystemClient';
const SUBSCREEN = 'version history panel';
const GET_VERSION_HISTORY = registerVersionHistoryQuery(getVersionHistory);

const ThemeVersionHistoryModalPanel = ({
  offeringId,
  onClose,
  onTrackInteraction,
  onTrackPageview
}) => {
  const handleClose = useCallback(evt => {
    onClose(evt);
    onTrackInteraction('close verion history panel', {
      subscreen: SUBSCREEN
    });
  }, [onClose, onTrackInteraction]);
  useEffect(() => {
    onTrackPageview({
      subscreen: SUBSCREEN
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/_jsx(CoreVersionHistoryPanel, {
    errorMessage: unescapedText(`marketplace-assets-ui.themes.details.themeInfo.versionHistoryPanel.error`),
    offeringId: offeringId,
    panelHeader: /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.themes.details.themeInfo.versionHistory"
        })
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: handleClose
      })]
    }),
    panelFooter: /*#__PURE__*/_jsx(UIButton, {
      use: "tertiary-light",
      onClick: handleClose,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.themes.details.themeInfo.versionHistoryPanel.close"
      })
    }),
    versionHistoryQuery: GET_VERSION_HISTORY
  });
};

ThemeVersionHistoryModalPanel.propTypes = {
  offeringId: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
  onTrackInteraction: PropTypes.func.isRequired,
  onTrackPageview: PropTypes.func.isRequired
};
export default ThemeVersionHistoryModalPanel;